import React from 'react';
import StyledFilterResultsBlock from '@blocks/filter-results-block/filter-results.block';
import StyledResultsBlock from '@blocks/results-block/results-block';
import useClientOnly from '@hooks/use-client-only';
import { useInstantSearch } from 'react-instantsearch';

const ContentHubResults = () => {
  const { indexUiState } = useInstantSearch();
  const isClientSide = useClientOnly();

  if (isClientSide) {
    return indexUiState && indexUiState.query ? (
      <StyledResultsBlock />
    ) : (
      <StyledFilterResultsBlock />
    );
  } else {
    return null;
  }
};

export default ContentHubResults;
